<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <div class="container-fluid">
    <div class="navbar-brand">Admin User</div>
    <div class=" ms-auto">
        <a class="btn btn-sm btn-outline-primary" [routerLink]="['/lo/admin/user/form', uuid ? uuid : '']">&#43; Add New User</a>
        <a class="btn btn-sm btn-outline-primary ms-2" [routerLink]="['/lo/admin/user/exiting']" *ngIf="uuid">&#43; Add Existing User</a>
    </div>
  </div>
</nav>
<hr/>
<app-table #table ></app-table>
